import Entity from "../../../class/abstract/Entity";

class ProspectPhase extends Entity {
    name = "";
    reference = "";
    color = null;
    order = 0;
    partnerships_id = 0;
    partnership_name = "";

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        var keys = Object.keys(this);
        var key = "";
        var i = 0;

        for(i in keys) {
            key = keys[i];

            if (datas[key] !== undefined)
                Reflect.set(this, key, datas[key]);
        }
    }
}

export default ProspectPhase;
